import React from 'react';
import { AuthorizerProvider } from '../auth/AuthorizerContext';
import { SupabasePersistorProvider } from './SupabasePersistorProvider';

interface AppProvidersProps {
  children: React.ReactNode;
  treeId: string;
}

/**
 * Composite provider that sets up core infrastructure dependencies:
 * - Auth (supabase client)
 * - Persistor (data persistence)
 */
export const AppProviders: React.FC<AppProvidersProps> = ({ children, treeId }) => {
  return (
    <AuthorizerProvider treeId={treeId}>
      <SupabasePersistorProvider>
        {children}
      </SupabasePersistorProvider>
    </AuthorizerProvider>
  );
};

